var map = {
	"./block-accordion/module.js": [
		52,
		13
	],
	"./block-blog-cover/module.js": [
		53,
		15
	],
	"./block-cover/module.js": [
		54,
		17
	],
	"./block-half/module.js": [
		55,
		0,
		20
	],
	"./block-icone/module.js": [
		56,
		0,
		21
	],
	"./block-loghi-noslider/module.js": [
		58,
		0,
		26
	],
	"./block-loghi/module.js": [
		57,
		0,
		27
	],
	"./block-steps/module.js": [
		59,
		14,
		28
	],
	"./block-title/module.js": [
		60,
		18
	],
	"./block-titolo-testo-immagine/module.js": [
		61,
		16
	],
	"./block-wysiwyg/module.js": [
		62,
		19
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 35;
module.exports = webpackAsyncContext;